"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Tag = require("../../components/Tag/Tag.util");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Tag = {
  defaultProps: {
    size: "small"
  },
  styles: function styles(theme) {
    return {
      root: {
        fontWeight: 900,
        borderRadius: 2,
        textTransform: "none",
        letterSpacing: "normal",
        padding: [Math.floor(theme.spacing.base / 4), theme.spacing.base / 2]
      },
      close: {
        "& svg": {
          backgroundColor: "unset",
          borderRadius: "unset",
          fill: function fill(_ref) {
            var fontColor = _ref.fontColor;
            return fontColor;
          },
          "&:hover, &:focus-visible": {
            backgroundColor: "unset",
            fill: function fill(_ref2) {
              var fontColor = _ref2.fontColor;
              return "".concat(fontColor, "60");
            }
          }
        }
      },
      compact: {
        fontWeight: "normal"
      },
      compactIcon: {
        paddingInlineEnd: 0
      },
      transluecentCompact: {
        fontWeight: 900
      },
      translucentClose: {
        "& svg": {
          backgroundColor: "unset",
          fill: _Tag.vars.get("mainColor"),
          "&:hover, &:focus-visible": {
            backgroundColor: "unset",
            fill: _Tag.vars.get("mainColor60")
          }
        }
      }
    };
  }
};
var _default = exports.default = Tag;